import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";

import AmityProvider from "../Bootstrap/AmityProvider";
import Bootstrap from "../Bootstrap/Bootstrap";
import ScrollToTop from "../ScrollToTop/ScrollToTop";

import { store } from "../../state";
import settings from "../../config/settings";

import Home from "../../pages/Home/Home";
import SignUp from "../../pages/SignUp/SignUp";
import SignIn from "../../pages/SignIn/SignIn";
import GoogleCallback from "../../pages/SignUp/GoogleCallback";
import PasswordRecovery from "../../pages/PasswordRecovery/PasswordRecovery";
import MyProfile from "../../pages/MyProfile/MyProfile";

import NewShirtView from "../../pages/NewItem/NewShirtView";
import UpgradeMembership from "../../pages/UpgradeMembership/UpgradeMembership";
import CheckoutPage from "../../pages/UpgradeMembership/CheckoutPage";

import Community from "../../pages/Community/Community";
import Collections from "../../pages/Collections/Collections";
import Store from "../../pages/Store/Store";
import SearchForCollectors from "../../pages/SearchForCollectors/SearchForCollectors";

import TermsAndConditions from "../../pages/TermsAndConditions/TermsAndConditions";
import PrivacyPolicy from "../../pages/PrivacyPolicy/PrivacyPolicy";
import CookiePolicy from "../../pages/CookiePolicy/CookiePolicy";
import FAQ from "../../pages/FAQ/FAQ";
import ContactUs from "../../pages/ContactUs/ContactUs";

import TopTeams from "../../pages/TopTeams/TopTeams";
import TopPlayers from "../../pages/TopPlayers/TopPlayers";
import TopUsersByQty from "../../pages/TopUsers/TopUsersByQty";
import AboutCollecticos from "../../pages/AboutCollecticos/AboutCollecticos";

import "./App.css";

const App = () => {
  return (
    <Provider store={store}>
      <BrowserRouter basename="/">
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={
              <Bootstrap>
                <Home />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/terms-and-conditions"
            element={
              <Bootstrap>
                <TermsAndConditions />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/privacy-policy"
            element={
              <Bootstrap>
                <PrivacyPolicy />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/cookie-policy"
            element={
              <Bootstrap>
                <CookiePolicy />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/about-collecticos"
            element={
              <Bootstrap>
                <AboutCollecticos />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/faq"
            element={
              <Bootstrap>
                <FAQ />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/contact-us"
            element={
              <Bootstrap>
                <ContactUs />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/sign-up"
            element={
              <Bootstrap>
                <SignUp />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/sign-in"
            element={
              <Bootstrap>
                <SignIn />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/my-profile/:userId/:tab/:section/:subsection"
            element={
              <Bootstrap>
                <MyProfile />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/my-profile/:userId/:tab/:section"
            element={
              <Bootstrap>
                <MyProfile />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/my-profile/:userId/:tab"
            element={
              <Bootstrap>
                <MyProfile />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/shirt/new"
            element={
              <AmityProvider>
                <Bootstrap>
                  <NewShirtView />
                </Bootstrap>
              </AmityProvider>
            }
          ></Route>
          <Route
            path="/upgrade-membership"
            element={
              <Bootstrap>
                <UpgradeMembership />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/checkout"
            element={
              <Bootstrap>
                <CheckoutPage />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/community"
            element={
              <AmityProvider>
                <Bootstrap>
                  <Community />
                </Bootstrap>
              </AmityProvider>
            }
          ></Route>
          <Route
            path="/store"
            element={
              <Bootstrap>
                <Store />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/shirts-collections"
            element={
              <Bootstrap>
                <Collections />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/shirts-collections/team/:teamId"
            element={
              <Bootstrap>
                <Collections />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/shirts-collections/player/:playerId"
            element={
              <Bootstrap>
                <Collections />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/top/teams"
            element={
              <Bootstrap>
                <TopTeams />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/top/players"
            element={
              <Bootstrap>
                <TopPlayers />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/top/users/qty"
            element={
              <Bootstrap>
                <TopUsersByQty />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/password-recovery/:code"
            element={
              <Bootstrap>
                <PasswordRecovery />
              </Bootstrap>
            }
          ></Route>
          <Route
            path="/search-for-collectors"
            element={
              <Bootstrap>
                <SearchForCollectors />
              </Bootstrap>
            }
          ></Route>
          <Route
            path={settings.google_redirect_uri}
            element={
              <Bootstrap>
                <GoogleCallback />
              </Bootstrap>
            }
          ></Route>
        </Routes>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
